import configModule from '../modules/RegistrationPage/store/config.module';
import { RootState } from './types';

const getters = {
  hasErrors(state: RootState) {
    return state.hasErrors;
  },
  error(state: RootState) {
    return state.errors[0];
  },
};

const mutations = {
  setError(state: RootState, error: string) {
    state.errors.push(error);
    state.hasErrors = true;
  },
};

export const registrationModule = {
  namespaced: true,
  modules: {
    config: configModule,
  },
  state: {
    hasErrors: false,
    errors: [],
  },
  mutations,
  getters,
};

export const storeConfig = {
  namespaced: true,
  modules: {
    registration: registrationModule,
  },
};

// export default new Vuex.Store<RootState>(storeConfig);
